//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
//import Components
import {Button, Row, Col, Form, FormGroup, Label, Input} from 'reactstrap'

import ImageSelector from '../../ImageSelector/ImageSelector';
import EditConfirmButton from '../../EditConfirmButton/EditConfirmButton';
import UpDownButton from '../../UpDownButton/UpDownButton';

import CardItemFormLine from './CardItemFormLine';
import * as departmentActions from '../../../HomepageManager/actions/departmentActions';

//import Styles

class DepartmentCardFormLine extends Component {

    constructor(props) {
        super(props);

        const items = props.data.items ? props.data.items : [];
        this.state = {
            items
        }
    }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    removeFormLine = (id) => {
        let items = [...this.state.items];
        items = items.filter((i) => {
            return i !== id;
        })
        this.setState({
            items
        })

        const {koName, koContent, enName, enContent} = this.props;

        this.props.onUpdate(
            this.props.dbPath,
            this.props.data.id, {
                type: this.props.type,
                name: {
                    en: enName,
                    ko: koName
                },
                content: {
                    en: enContent,
                    ko: koContent
                },
                promotion: this.props.promotion,
                items,
            })
    }

    render(){
        const {koName, koContent, enName, enContent} = this.props;
        const {editing} = this.props;

        //NOTE : 여기서 Order에 따라서 sort를 하자
        const filteredCards = this.props.cards.filter((c) => {
            for(let i = 0; i < this.state.items.length; ++i){
                if(this.state.items[i] === c.id) {
                    return true;
                }
            }
        });

        const sortedCards = filteredCards && filteredCards.sort((a, b) => {
            if(a.order !== undefined && b.order !== undefined) {
                return a.order - b.order;
            }
        });

        const renderCards = (
            sortedCards && sortedCards.map((item, index) => {
                return (
                    <CardItemFormLine 
                        dbPath="cards"
                        storagePath="card_images/"
                        data={item}
                        dataArray={filteredCards}
                        index={index}
                        key={index}
                        onRemove={this.props.onRemove}
                        onRemoveFormLine = {this.removeFormLine}
                        onUpdate={this.props.onUpdate}
                    />
                );
            })
        );

        return (
            <div>
                <Row>
                    <Col>
                        <ImageSelector 
                            storagePath={this.props.storagePath}
                            imageId={this.props.data.id}
                        />
                    </Col>
                    <Col>
                        <Form>
                            <FormGroup>
                                <Label className="mr-sm-2">제목</Label>
                                <Input
                                    type="text"
                                    name="koName"
                                    value={koName}
                                    onChange={this.props.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label className="mr-sm-2">내용</Label>
                                <Input
                                    type="textarea"
                                    name="koContent"
                                    value={koContent}
                                    onChange={this.props.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col>
                        <Form>
                            <FormGroup>
                                <Label className="mr-sm-2">Title</Label>
                                <Input
                                    type="text"
                                    name="enName"
                                    value={enName}
                                    onChange={this.props.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label className="mr-sm-2">Content</Label>
                                <Input
                                    type="textarea"
                                    name="enContent"
                                    value={enContent}
                                    onChange={this.props.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col sm={1}>
                        <UpDownButton 
                            disabled={this.props.editAnything}
                            onOrderUp={() => {
                                this.props.onDataOrderSwitch(this.props.dbPath, this.props.index, this.props.index - 1);
                            }}
                            onOrderDown={() => {
                                this.props.onDataOrderSwitch(this.props.dbPath, this.props.index, this.props.index + 1);
                            }}
                        />
                        <EditConfirmButton 
                            editing={editing}
                            onConfirm={ () => {
                                this.props.onUpdate(
                                    this.props.dbPath,
                                    this.props.data.id, {
                                        type : this.props.type,
                                        name : {
                                            en: enName,
                                            ko: koName
                                        }, 
                                        content : {
                                            en: enContent,
                                            ko: koContent
                                        },
                                        items : [
                                            ...this.state.items
                                        ],
                                        promotion: this.props.promotion
                                    })
                            }}
                            onToggleEditing={() => {
                                this.props.onToggleEditing()
                            }}
                            onRemove={() => {
                                this.props.onRemove(this.props.dbPath, 
                                                    this.props.storagePath, {
                                                        id : this.props.data.id,
                                                    })
                            }}
                        />
                    </Col>
                </Row>
                {
                    renderCards
                }
                <div 
                    className="sub-category-add-btn"
                    onClick={() => {
                        if(editing){

                            let orders = [];
                            for(let i = 0; i < sortedCards.length; ++i){
                                orders.push(sortedCards[i].order);
                            }
                            const maxOrder = Math.max(...orders);

                            this.props.addNewDefaultCard((dbKey) => {
                                let items = [...this.state.items]
                                items.push(dbKey);
                                this.setState({
                                    items
                                });
                                this.props.onUpdate(
                                    this.props.dbPath,
                                    this.props.data.id, {
                                        type : this.props.type,
                                        name : {
                                            en: enName,
                                            ko: koName
                                        }, 
                                        content : {
                                            en: enContent,
                                            ko: koContent
                                        },
                                        promotion: this.props.promotion,
                                        items,
                                    })
                            }, maxOrder + 1);
                        }
                    }}
                >
                   카드 추가 
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state)=> {
    return {
        cards : state.admin.homepage.cards
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addNewDefaultCard : (successFunc, newOrder)=> {
            dispatch(departmentActions.addNewDefaultDepartmentCard(successFunc, newOrder));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DepartmentCardFormLine);

DepartmentCardFormLine.propTypes = {
    data : PropTypes.object.isRequired,
    onUpdate : PropTypes.func.isRequired,
    onRemove : PropTypes.func.isRequired,
    storagePath : PropTypes.string.isRequired,
}

DepartmentCardFormLine.defaultProps = {
    onUpdate : null,
    onRemove : null,
}


// WEBPACK FOOTER //
// ./src/pages/Admin/Components/AdminDepartmentFormManager/FormLines/DepartmentCardFormLine.js